// ═══ 신청 3단계 공용 조각 (신고 371 N) — 폼 카드·라벨/입력·안내·CTA 바 ═══
// 시안 final/screens-b.html 의 .fcard / .fld / .flab / .fin / .nb / .amber / .ctad·.ctam 대응.
// 색·반경은 v2/theme.js `T`/`R` 만 쓴다(hex 리터럴 0 — v2-kit.test.js 가드).
import React from 'react';
import { T, R, S, FONT } from '../../../theme';

export var card = { background: T.card, border: '1px solid ' + T.bd, borderRadius: R.card,
  display: 'flex', flexDirection: 'column', gap: 14 };

export var question = { fontSize: 15, fontWeight: 800, letterSpacing: '-.3px', color: T.ink };

export var input = Object.assign({}, S.input, { height: 38, fontSize: 13.5 });
export var textarea = Object.assign({}, S.textarea, { minHeight: 68, fontSize: 13.5 });
export var select = Object.assign({}, input, { cursor: 'pointer' });

var fld = { display: 'flex', flexDirection: 'column', gap: 5, minWidth: 0 };
var lab = { display: 'flex', alignItems: 'center', gap: 3, fontSize: FONT.label, fontWeight: 700, color: T.muted };
var req = { color: T.danger, fontSize: FONT.label };
export var errSt = { fontSize: 11.5, color: T.danger, lineHeight: 1.5 };
export var warnSt = { fontSize: 11.5, color: T.warn, lineHeight: 1.5 };

/// 라벨 + 입력 + 인라인 오류 한 줄. props: { label, required, error, htmlFor, children }
export function Field(props) {
  return (<div style={fld}>
    <label style={lab} htmlFor={props.htmlFor}>
      <span>{props.label}</span>
      {props.required ? <b style={req}>*</b> : null}
    </label>
    {props.children}
    {props.error ? <div style={errSt} role="alert">{props.error}</div> : null}
  </div>);
}

var note = { display: 'flex', gap: 8, padding: '10px 12px', borderRadius: R.md, background: T.head,
  border: '1px solid ' + T.bd, fontSize: 11.5, color: T.sub, lineHeight: 1.6 };

/// 회색 안내 박스 (.nb).
export function NoteBox(props) {
  return <div style={props.tone === 'accent' ? Object.assign({}, note, { background: T.accentTint, border: '1px solid ' + T.accentBd, color: T.accentPress }) : note}>{props.children}</div>;
}

var amber = { display: 'flex', flexDirection: 'column', gap: 9, padding: '12px 14px', borderRadius: R.md,
  background: T.warnTint, border: '1px solid ' + T.warnBd, color: T.warn };
var amberTitle = { fontSize: 13, fontWeight: 800, letterSpacing: '-.2px' };
var amberSub = { fontSize: 11.5, lineHeight: 1.6 };

/// 앰버 블록 (.amber) — OCR 프리필 배너 / OCR 실패 안내.
export function AmberBox(props) {
  return (<div style={amber} role={props.role}>
    <div>
      <div style={amberTitle}>{props.title}</div>
      {props.sub ? <div style={amberSub}>{props.sub}</div> : null}
    </div>
    {props.children ? <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>{props.children}</div> : null}
  </div>);
}

export var linkBtn = { border: 0, background: 'none', padding: 0, fontFamily: 'inherit', fontSize: 12,
  fontWeight: 700, color: T.accentPress, cursor: 'pointer', textDecoration: 'underline' };

var ctaBtn = { display: 'inline-flex', alignItems: 'center', justifyContent: 'center', height: 44, padding: '0 18px',
  borderRadius: R.md, fontSize: 13.5, fontWeight: 700, fontFamily: 'inherit', cursor: 'pointer', minWidth: 0 };

export var btnNavy = Object.assign({}, ctaBtn, { background: T.navy, border: '1px solid ' + T.navy, color: T.card });
export var btnPlain = Object.assign({}, ctaBtn, { background: T.card, border: '1px solid ' + T.bd, color: T.body });
export var btnDisabled = { opacity: .55, cursor: 'default' };

var ctaDesk = { display: 'flex', gap: 10, justifyContent: 'flex-end' };
var ctaMobile = { position: 'fixed', insetInlineStart: 0, insetInlineEnd: 0, bottom: 60, zIndex: 55,
  display: 'flex', gap: 10, padding: '10px 14px', background: T.card, borderTop: '1px solid ' + T.bd };

/// 하단 CTA — 데스크톱은 카드 안 우측 정렬, ≤768 은 하단 탭(60) 위 고정 바.
export function CtaBar(props) {
  if (!props.isMobile) return <div style={ctaDesk}>{props.children}</div>;
  return (<React.Fragment>
    <div style={{ height: 8 }} />
    <div style={ctaMobile}>{props.children}</div>
  </React.Fragment>);
}
